import React, { useState, useEffect } from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiEdit2,
  FiSave
} from "react-icons/fi";
import { MdOutlineArrowForwardIos, MdOutlineArrowBackIos } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { LuArrowLeft, LuX } from 'react-icons/lu';



export default function ViewChapters({
  currentChapter,
  prevChapter,
  nextChapter,
  onSave
}) {
  const [editMode, setEditMode] = useState(false);
  const [editedChapter, setEditedChapter] = useState(currentChapter);

  // Chapter name change
  const handleChapterChange = (value) => {
    setEditedChapter((prev) => ({
      ...prev,
      chapterName: value
    }));
  };

  // Paragraph change
  const handleParaChange = (index, field, value) => {
    const updatedParas = [...editedChapter.paragraphs];
    updatedParas[index] = {
      ...updatedParas[index],
      [field]: value
    };

    setEditedChapter((prev) => ({
      ...prev,
      paragraphs: updatedParas
    }));
  };
  const handleParaQuillChange = (index, field, value) => {
    setEditedChapter((prev) => {
      const currentValue = prev.paragraphs[index]?.[field];

      // 🛑 Prevent unnecessary updates (this fixes the loop)
      if (currentValue === value) return prev;

      const updatedParas = [...prev.paragraphs];
      updatedParas[index] = {
        ...updatedParas[index],
        [field]: value
      };

      return {
        ...prev,
        paragraphs: updatedParas
      };
    });
  };


  const discardEditSave = () => {
    setEditMode(false);

  }
  // Save
  const handleSave = () => {
    setEditMode(false);

    onSave({
      chapterId: editedChapter.id,
      chapterName: editedChapter.chapterName,
      paragraphs: editedChapter.paragraphs.map((p) => ({
        paraTitle: p.paraTitle,
        paraSubtitle: p.paraSubtitle,
        paraDesc: p.paraDesc
      }))
    });
  };

  // Sync chapter
  useEffect(() => {
    setEditedChapter(currentChapter);
    setEditMode(false);
  }, [currentChapter]);

  // Toolbar actions
  const formatText = (command) => {
    document.execCommand(command, false, null);
  };

  return (
    <>
      <div className="flex items-center justify-between pb-4 border-b border-gray-300 mb-8">
        <div className="flex items-center gap-4">
          <div onClick={prevChapter} className="bg-indigo-100 p-2 text-indigo-600 rounded-md">
            <MdOutlineArrowBackIos size={24} />
          </div>
          <div onClick={nextChapter} className="bg-indigo-100 p-2 text-indigo-600 rounded-md">
            <MdOutlineArrowForwardIos size={24} />
          </div>
        </div>

        <div className="flex items-center gap-4">
          {editMode ? <button
            onClick={discardEditSave}
            className="flex items-center gap-4 px-5 py-2 border border-gray-300 text-lg font-medium text-indigo-600 rounded-md"
          >
            <LuX />
            Discard
          </button> : null}
          <button
            onClick={editMode ? handleSave : () => setEditMode(true)}
            className="flex items-center gap-4 px-5 py-2 border border-gray-300 text-lg font-medium text-indigo-600 rounded-md"
          >
            {editMode ? <FiSave /> : <FiEdit2 />}
            {editMode ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {editedChapter &&
        <>
          {editMode ?
            <>
              <header className="mb-8">
                <h2 className="text-3xl font-bold mb-2"> Chapter {String(editedChapter.chapterNo).padStart(2, "0")}</h2>

                <input type="text"
                  value={editedChapter.chapterName || ""}
                  onChange={(e) => handleChapterChange(e.target.value)}
                  placeholder="Chapter Name" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-[#212121] textblack" />

                {/* <input type="text" placeholder="The company headquarters are located in Farmington, Connecticut." className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-[#212121] textblack" /> */}

                {/* <span className="text-indigo-600 font-medium capitalize"> Chapter {String(editedChapter.chapterNo).padStart(2, "0")}:{" "}

                </span> */}
              </header>
              {editedChapter.paragraphs.map((para, i) => (
                <div className="border border-gray-300 rounded-xl p-6 space-y-4 mb-6">
                  <h3 className="font-semibold text-[#212121]">Paragraph {i + 1}</h3>
                  <input type="text" value={para.paraTitle || ""} onChange={(e) => handleParaChange(i, "paraTitle", e.target.value)}
                    placeholder="Paragraph Title" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-[#212121] textblack" />
                  <input type="text" value={para.paraSubtitle || ""} onChange={(e) => handleParaChange(i, "paraSubtitle", e.target.value)}
                    placeholder="Paragraph Subtitle" className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none placeholder:text-[#212121] textblack" />
                  <div className="border border-gray-300 rounded-md overflow-hidden">
                    <div className="border rounded p-2">
                      <div className="flex gap-2 mb-2 border-b pb-2">
                        <button onClick={() => formatText("bold")} className="px-2 py-1 border rounded">B</button>
                        <button onClick={() => formatText("italic")} className="px-2 py-1 border rounded">I</button>
                        <button onClick={() => formatText("underline")} className="px-2 py-1 border rounded">U</button>
                        <button onClick={() => formatText("insertUnorderedList")} className="px-2 py-1 border rounded">• List</button>
                        <button onClick={() => formatText("insertOrderedList")} className="px-2 py-1 border rounded">1. List</button>
                      </div>

                      <div
                        contentEditable
                        className="min-h-[120px] outline-none"
                        dangerouslySetInnerHTML={{ __html: para.paraDesc || "" }}
                        onInput={(e) =>
                          handleParaChange(
                            i,
                            "paraDesc",
                            e.currentTarget.innerHTML
                          )
                        }
                      />
                    </div>

                    {/* <ReactQuill
                      theme="snow"
                      value={para.paraDesc}
                      onChange={(value) =>
                        handleParaQuillChange(
                          i,
                          "paraDesc",
                          value
                        )
                      }
                      className="custom-quill"
                    /> */}

                  </div>
                </div>
              ))}
            </>
            :
            <>
              <header className="mb-8">
                <h2 className="text-3xl font-bold mb-2">{editedChapter.chapterName || ""}</h2>
              </header>

              <div className="space-y-8">
                {editedChapter.paragraphs.map((para, i) => (
                  <section key={i} className="space-y-4">
                    <h3 className="text-xl font-bold text-[#1a1a1a]">{para.paraTitle}</h3>
                    <div
                      className="text-gray-600 leading-relaxed text-base md:text-lg"
                      dangerouslySetInnerHTML={{ __html: para.paraDesc }}
                    />
                  </section>
                ))}
              </div>
            </>}
        </>}
    </>
  );
}